<div class="flex-container">
  <div class="flex-row">
    <div class="flex-col-12">
      <ng-content></ng-content>
    </div>
  </div>
</div>
